import { FormControl, InputLabel, MenuItem, Typography } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { Flag } from '../types';

type CurrencyOptionProps = {
  id: string;
  options: Flag[];
  label: string;
  value: string;
  onChange: (newValue: string) => void;
  disabled: boolean;
  isSource?: boolean;
};

const CurrencyOption = ({
  id,
  options,
  label = 'Source Currency',
  value,
  onChange,
  disabled = false,
}: CurrencyOptionProps) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };
  return (
    <FormControl required fullWidth>
      <InputLabel id={`label-${id}`} style={{ left: -15 }}>
        {label}
      </InputLabel>
      <Select
        variant="standard"
        labelId={`label-${id}`}
        name={id}
        id={id}
        label={label}
        value={value}
        disabled={disabled}
        onChange={handleChange}
      >
        {options.map((option) => (
          <MenuItem value={option.value} key={option.value}>
            {option.icon}
            <Typography sx={{ ml: 1, display: 'inline-block' }}>
              {option.label}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencyOption;
